<template>
    <div class="signuplist">
        <van-checkbox-group v-model="result">
        <div class="sulist">

            <div class="su-item" v-for="(item,index) in list" :key="index">
                <van-checkbox :name="item.id+'_'+item.buyer_id" class="su-tt">{{item.user_name}}</van-checkbox>
                <div class="su-bo">
                    <div>
                        <div class="subtitle">科目：</div>
                        <div class="subvalue oneline">{{item.pname}}</div>
                    </div>
                    <div>
                        <div class="subtitle">证书：</div>
                        <div class="subvalue oneline">{{item.sku_name}}</div>
                    </div>
                    <div>
                        <div class="subtitle">确认时间：</div>
                        <div class="subvalue oneline">{{item.sign_time}}</div>
                    </div>
                    <div>
                        <div class="subtitle">付款时间：</div>
                        <div class="subvalue oneline">{{item.pay_time}}</div>
                    </div>
                </div>
<!--                <div class="su-bo2">-->
<!--                    <div>10-23 截止报名</div>-->
<!--                    <div class="mvbutton default">凑满30人开课哦</div>-->
<!--                </div>-->
                <div class="mvbutton btn">{{item.stateName}}</div>

            </div>

        </div>
        </van-checkbox-group>
        <div class="footer footer-btn">
            <div class="mvbutton" @click="goNext">下一步</div>
        </div>
    </div>
</template>
<script>
    import './index.less'
    import {Cell, CellGroup, Area, Popup,Field,Tag,Checkbox, CheckboxGroup,Toast} from 'vant'
    export default {
        computed: {
        },
        data() {
            return {
                area: false,
                userInfo: '',
                address: "",
                street:"",
                list:[],
                params:{page:1},
                result:[]
            }
        },
        components: {
            Cell,
            CellGroup,
            Area,
            Field,
            Popup,
            Tag,vanCheckbox:Checkbox,vanCheckboxGroup:CheckboxGroup
        },
        methods: {
            godetail(){
                this.$router.push({name:'signdetail',params:{id:1}})
            },
            getOrderlist()
            {
                this.$api.order.orderlist(this.params).then((res)=>{
                    if(res.code==200){
                        this.list = res.data.list
                    }
                    this.finished   =   true
                    this.loading = false;
                })
            },
            goNext()
            {
                if(this.result.length<1)
                {
                    Toast.fail('请选择人员');
                    return false;
                }
                let ids = this.result.join(",");
                this.$router.push({path:'/signdetail',query:{ids:ids}})
            }
        },
        mounted() {
            this.getOrderlist()
        }
    }
</script>
